
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/who-is-daniel-petkevich",
      function () {
        return require("private-next-pages/who-is-daniel-petkevich.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/who-is-daniel-petkevich"])
      });
    }
  